import { Check, MessageSquare } from 'lucide-react';
import { CLOSED_STATUSES } from '../statusMeta';
import type { Task } from '@/types/task';

const PILL = 'inline-flex items-center gap-2 rounded-[20px] px-[14px] py-2 text-[13px]';

interface TaskDetailFooterProps {
  task: Task;
  /** What the primary action is called where this panel is hosted. */
  ctaLabel: string;
  onMarkDone: () => void;
  onOpenInChat: () => void;
}

/**
 * The panel's actions. "Mark as Done" is hidden once a task is finished or
 * dismissed, where it would have nothing left to do.
 */
export const TaskDetailFooter = ({
  task, ctaLabel, onMarkDone, onOpenInChat,
}: TaskDetailFooterProps) => (
  <div className="flex shrink-0 items-center justify-end gap-[9px] border-t border-[rgba(0,0,0,0.08)] bg-white px-4 py-3">
    {CLOSED_STATUSES.includes(task.status) ? null : (
      <button
        type="button"
        className={`${PILL} border border-[rgba(0,0,0,0.14)] bg-white text-[#181818] hover:bg-[#F6F5F1]`}
        onClick={onMarkDone}
      >
        <Check className="size-[15px]" aria-hidden />
        Mark as Done
      </button>
    )}
    <button
      type="button"
      className={`${PILL} min-w-0 border border-[#181818] bg-[#181818] font-medium text-white hover:bg-black`}
      onClick={onOpenInChat}
    >
      <MessageSquare className="size-[15px] shrink-0" aria-hidden />
      <span className="truncate">{ctaLabel}</span>
    </button>
  </div>
);
